module.exports = __webpack_public_path__ + "static/media/file-image.ce49319e.svg";